export const getInitialValue = ({ description }) => ({
  description: {
    html: description || ''
  }
})
